import { z } from 'zod';
import type { AISchemaField, UISchemaField } from '../types/index';

export const bentoAISchema: AISchemaField[] = [
  { name: 'eyebrow', type: 'string', required: false, max: 30 },
  { name: 'headline', type: 'string', required: true, max: 80 },
  {
    name: 'cells',
    type: 'array<object>',
    required: true,
    fields: [
      { name: 'title', type: 'string', required: true, max: 50 },
      { name: 'description', type: 'string', required: false, max: 160 },
      { name: 'icon', type: 'string', required: false, max: 30, hint: 'lucide icon name (optional)' },
      { name: 'image', type: 'image_url', required: false },
      { name: 'span', type: 'string', required: false, hint: 'small | wide | tall | large' },
    ],
  },
];

export const bentoUISchema: UISchemaField[] = [
  { name: 'eyebrow', type: 'text', label: 'Eyebrow', max: 30 },
  { name: 'headline', type: 'text', label: 'Headline', required: true, max: 80 },
  { name: 'cells', type: 'feature_list', label: 'Bento cells', required: true },
];

export const bentoZodSchema = z.object({
  eyebrow: z.string().max(30).optional().nullable(),
  headline: z.string().min(1).max(80),
  cells: z
    .array(
      z.object({
        title: z.string().max(50),
        description: z.string().max(160).optional().nullable(),
        icon: z.string().max(30).optional().nullable(),
        image: z.string().optional().nullable(),
        span: z.enum(['small', 'wide', 'tall', 'large']).optional().nullable(),
      }),
    )
    .min(3)
    .max(8),
});

export type BentoContent = z.infer<typeof bentoZodSchema>;

export const bentoSample: BentoContent = {
  eyebrow: 'Everything in one place',
  headline: 'A complete creative system.',
  cells: [
    { title: 'Capture', description: 'Studio-grade media in one tap.', span: 'wide', image: null },
    { title: 'Edit', description: 'AI-assisted color and audio.', span: 'small', image: null },
    { title: 'Collaborate', description: 'Real-time review with stakeholders.', span: 'tall', image: null },
    { title: 'Ship', description: 'Export-ready presets for every platform.', span: 'small', image: null },
    { title: 'Archive', description: 'Searchable cloud library.', span: 'wide', image: null },
  ],
};
